import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showIcon", "area"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Checkbox as CheckboxChakra } from '@chakra-ui/react';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Checkbox(props) {
  var showIcon = props.showIcon,
    area = props.area,
    rest = _objectWithoutProperties(props, _excluded);
  return _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    "data-testid": "box-wrapper"
  }, checkboxStyle(props.variant === 'border')), props.checkboxWrapperStyles), {}, {
    children: _jsx(CheckboxChakra, _objectSpread(_objectSpread({
      spacing: "sm",
      alignItems: "flex-start"
    }, rest), {}, {
      children: props.children
    }))
  }));
}
var checkboxStyle = isBorder => ({
  border: isBorder ? "1px solid var(--chakra-colors-lightGrey4)" : 0,
  w: '100%',
  bg: isBorder ? 'lightGrey5' : '',
  p: isBorder ? 'md' : '0',
  justifyContent: 'center',
  my: 'sm'
});